<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">DATA CLEANUP - DAY BY DAY SCAN</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Data Cleanup</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Date Range & Controls -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h5 class="mb-0"><i class="mdi mdi-calendar-range me-2"></i>Select Date Range & Start Scan</h5>
                  </div>
                  <div class="card-body">
                    <div class="row g-3 align-items-end">
                      <div class="col-md-2">
                        <label class="form-label">From Date:</label>
                        <input v-model="dateFrom" class="form-control" type="date" :disabled="isProcessing">
                      </div>
                      <div class="col-md-2">
                        <label class="form-label">To Date:</label>
                        <input v-model="dateTo" class="form-control" type="date" :disabled="isProcessing">
                      </div>
                      <div class="col-md-2">
                        <label class="form-label">Batch Size:</label>
                        <select v-model="batchSize" class="form-select" :disabled="isProcessing">
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20 (Recommended)</option>
                          <option value="50">50 (Fast)</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                      <div class="col-md-6 text-end">
                        <button @click="loadDaysWithRecords()"
                                class="btn btn-outline-primary me-2"
                                :disabled="isProcessing || loading">
                          <i class="mdi mdi-magnify me-1"></i>
                          Load Days
                        </button>
                        <button v-if="daysWithRecords.length > 0 && !isProcessing && !scanComplete"
                                @click="startDayByDayScan()"
                                class="btn btn-success me-2">
                          <i class="mdi mdi-play me-1"></i>
                          Start Day-by-Day Scan
                        </button>
                        <button v-if="isProcessing"
                                @click="stopProcessing()"
                                class="btn btn-danger">
                          <i class="mdi mdi-stop me-1"></i>
                          Stop Scan
                        </button>
                        <button v-if="scanComplete || orphanedBills.length > 0"
                                @click="resetScan()"
                                class="btn btn-secondary">
                          <i class="mdi mdi-refresh me-1"></i>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards -->
            <div class="row mb-4" v-if="daysWithRecords.length > 0">
              <div class="col-md-3">
                <div class="card bg-primary text-white">
                  <div class="card-body text-center">
                    <h6 class="text-white-50 mb-1">Total Days</h6>
                    <h2 class="text-white mb-0">{{ totalDays }}</h2>
                    <small>Days with PAID records</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card bg-info text-white">
                  <div class="card-body text-center">
                    <h6 class="text-white-50 mb-1">Total Records</h6>
                    <h2 class="text-white mb-0">{{ numberFormat(totalRecords) }}</h2>
                    <small>PAID bills in range</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card bg-success text-white">
                  <div class="card-body text-center">
                    <h6 class="text-white-50 mb-1">Days Completed</h6>
                    <h2 class="text-white mb-0">{{ completedDays }}/{{ totalDays }}</h2>
                    <small>{{ daysProgress }}% complete</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card bg-danger text-white">
                  <div class="card-body text-center">
                    <h6 class="text-white-50 mb-1">Orphaned Found</h6>
                    <h2 class="text-white mb-0">{{ numberFormat(totalOrphanedFound) }}</h2>
                    <small>Bills without transactions</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Overall Progress -->
            <div class="row mb-4" v-if="isProcessing || completedDays > 0">
              <div class="col-12">
                <div class="card border-info">
                  <div class="card-header bg-info text-white">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <i class="mdi mdi-chart-timeline-variant me-2"></i>
                        Overall Progress
                      </h5>
                      <span>{{ totalScannedRecords }} records scanned</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- Days Progress Bar -->
                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>Days: {{ completedDays }}/{{ totalDays }}</span>
                        <span>{{ daysProgress }}%</span>
                      </div>
                      <div class="progress" style="height: 25px;">
                        <div class="progress-bar bg-success progress-bar-striped"
                             :class="{'progress-bar-animated': isProcessing}"
                             :style="{width: daysProgress + '%'}">
                          {{ daysProgress }}%
                        </div>
                      </div>
                    </div>

                    <!-- Time Stats -->
                    <div class="row">
                      <div class="col-md-3">
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock-outline text-info me-2 font-size-24"></i>
                          <div>
                            <small class="text-muted d-block">Elapsed Time</small>
                            <strong>{{ formatDuration(totalElapsedTime) }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-timer-sand text-warning me-2 font-size-24"></i>
                          <div>
                            <small class="text-muted d-block">Est. Remaining</small>
                            <strong class="text-warning">{{ formatDuration(estimatedTotalTimeRemaining) }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-speedometer text-success me-2 font-size-24"></i>
                          <div>
                            <small class="text-muted d-block">Speed</small>
                            <strong>{{ overallSpeed }} records/sec</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock-check text-primary me-2 font-size-24"></i>
                          <div>
                            <small class="text-muted d-block">Est. Completion</small>
                            <strong>{{ estimatedCompletionTime }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Days List -->
            <div class="row mb-4" v-if="daysWithRecords.length > 0">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white">
                    <h5 class="mb-0">Days to Process</h5>
                  </div>
                  <div class="card-body">
                    <div class="d-flex flex-wrap gap-2">
                      <span v-for="(day, index) in daysWithRecords"
                            :key="day.date"
                            class="badge p-2"
                            :class="getDayBadgeClass(day, index)"
                            style="font-size: 0.85rem;">
                        <i :class="getDayIcon(day, index)" class="me-1"></i>
                        {{ formatDateShort(day.date) }}
                        <span class="ms-1 badge bg-white text-dark">{{ day.count }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Current Day Processing -->
            <div class="row mb-4" v-if="currentDay && isProcessing">
              <div class="col-12">
                <div class="card border-primary">
                  <div class="card-header bg-primary text-white">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <i class="mdi mdi-calendar-today mdi-spin me-2"></i>
                        Processing: {{ formatDateLong(currentDay.date) }}
                      </h5>
                      <span class="badge bg-white text-primary">{{ numberFormat(currentDayTotal) }} Records</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- Current Day Progress -->
                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>{{ currentDayStatus }}</span>
                        <span>{{ currentDayScanned }}/{{ currentDayTotal }} ({{ currentDayProgress }}%)</span>
                      </div>
                      <div class="progress" style="height: 20px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated"
                             :class="currentDayOrphaned > 0 ? 'bg-danger' : 'bg-info'"
                             :style="{width: currentDayProgress + '%'}">
                          {{ currentDayProgress }}%
                        </div>
                      </div>
                    </div>

                    <!-- Current Day Stats -->
                    <div class="row">
                      <div class="col-md-3">
                        <small class="text-muted">Elapsed:</small>
                        <strong class="d-block">{{ formatDuration(currentDayElapsed) }}</strong>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Remaining:</small>
                        <strong class="d-block text-warning">{{ formatDuration(currentDayRemaining) }}</strong>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Speed:</small>
                        <strong class="d-block">{{ currentDaySpeed }} bills/sec</strong>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Orphaned Found:</small>
                        <strong class="d-block" :class="currentDayOrphaned > 0 ? 'text-danger' : 'text-success'">
                          {{ currentDayOrphaned }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Orphaned Records Found -->
            <div class="row mb-4" v-if="orphanedBills.length > 0 && !isProcessing">
              <div class="col-12">
                <div class="card border-danger">
                  <div class="card-header bg-danger text-white">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <i class="mdi mdi-alert-octagon me-2"></i>
                        {{ orphanedBills.length }} Orphaned Records Found - {{ formatDateLong(stoppedAtDate) }}
                      </h5>
                      <div>
                        <button @click="deleteAllOrphaned()"
                                class="btn btn-light btn-sm me-2"
                                :disabled="isDeleting">
                          <i class="mdi mdi-delete-sweep me-1"></i>
                          Delete All ({{ orphanedBills.length }})
                        </button>
                        <button @click="continueAfterCleanup()"
                                class="btn btn-outline-light btn-sm"
                                :disabled="isDeleting || orphanedBills.length > 0">
                          <i class="mdi mdi-play me-1"></i>
                          Continue Scan
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Deletion Progress -->
                  <div class="card-body border-bottom" v-if="isDeleting">
                    <div class="d-flex justify-content-between mb-2">
                      <span>Deleting: {{ deletedCount }}/{{ totalToDelete }}</span>
                      <span>{{ formatDuration(deleteTimeRemaining) }} remaining</span>
                    </div>
                    <div class="progress" style="height: 20px;">
                      <div class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
                           :style="{width: deletionProgress + '%'}">
                        {{ Math.round(deletionProgress) }}%
                      </div>
                    </div>
                  </div>

                  <!-- Orphaned Records Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark sticky-top">
                        <tr>
                          <th>NO.</th>
                          <th>Bill No</th>
                          <th>Description</th>
                          <th>Customer</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in orphanedBills" :key="item.billNo" class="table-danger">
                          <td>{{ index + 1 }}</td>
                          <td><strong class="text-danger">{{ item.billNo }}</strong></td>
                          <td>
                            {{ item.incomeTypeDescription || 'N/A' }}
                            <small class="text-muted d-block">{{ item.feeDescription || '' }}</small>
                          </td>
                          <td>
                            {{ item.names || 'Unknown' }}
                            <small class="text-muted d-block">ID: {{ item.idNo || 'N/A' }}</small>
                          </td>
                          <td class="text-end">{{ formatPrice(item.detailAmount || 0) }}</td>
                          <td>{{ formatDate(item.dateCreated) }}</td>
                          <td>
                            <button @click="deleteSingleRecord(item.billNo)"
                                    class="btn btn-danger btn-sm"
                                    :disabled="isDeleting">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Scan Complete - All Clear -->
            <div class="row mb-4" v-if="scanComplete && orphanedBills.length === 0">
              <div class="col-12">
                <div class="card border-success">
                  <div class="card-body text-center py-5">
                    <i class="mdi mdi-check-circle text-success" style="font-size: 100px;"></i>
                    <h2 class="text-success mt-4">All Clear!</h2>
                    <p class="lead mb-2">
                      Successfully scanned <strong>{{ numberFormat(totalScannedRecords) }}</strong> records
                      across <strong>{{ completedDays }}</strong> days.
                    </p>
                    <p class="text-muted">All bills have corresponding transactions. No orphaned records found.</p>
                    <p class="text-muted">Total time: <strong>{{ formatDuration(totalElapsedTime) }}</strong></p>
                    <button @click="resetScan()" class="btn btn-outline-success btn-lg mt-3">
                      <i class="mdi mdi-refresh me-2"></i>
                      Start New Scan
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div class="row" v-if="loading">
              <div class="col-12">
                <div class="card">
                  <div class="card-body text-center py-5">
                    <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h4>{{ loadingMessage }}</h4>
                  </div>
                </div>
              </div>
            </div>

            <!-- Initial State -->
            <div class="row" v-if="!loading && daysWithRecords.length === 0 && !scanComplete && !isProcessing">
              <div class="col-12">
                <div class="card">
                  <div class="card-body text-center py-5">
                    <i class="mdi mdi-calendar-search text-muted" style="font-size: 100px;"></i>
                    <h4 class="mt-4">Select Date Range to Begin</h4>
                    <p class="text-muted">Choose a date range above and click "Load Days" to see days with PAID records.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Alert Toast -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">{{ message }}</div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import moment from "moment";

export default {
  name: "CleanupPage",
  components: {
    NavigationBar
  },
  data() {
    return {
      // Loading states
      loading: false,
      loadingMessage: '',
      isProcessing: false,
      isDeleting: false,
      stopRequested: false,
      scanComplete: false,

      // Date range
      dateFrom: '',
      dateTo: '',
      batchSize: '20',

      // Days data
      daysWithRecords: [],
      totalDays: 0,
      totalRecords: 0,
      completedDays: 0,
      currentDayIndex: -1,

      // Current day processing
      currentDay: null,
      currentDayBills: [],
      currentDayScanned: 0,
      currentDayTotal: 0,
      currentDayOrphaned: 0,
      currentDayStatus: '',
      currentDayStartTime: null,
      currentDayElapsed: 0,
      currentDayTimer: null,

      // Overall stats
      totalScannedRecords: 0,
      totalOrphanedFound: 0,
      totalStartTime: null,
      totalElapsedTime: 0,
      totalTimer: null,

      // Orphaned records
      orphanedBills: [],
      stoppedAtDate: null,

      // Deletion
      deletedCount: 0,
      totalToDelete: 0,
      deletionProgress: 0,
      deleteStartTime: null,
      deleteElapsedTime: 0,
      deleteTimer: null,

      // Alerts
      alert: { success: false, info: false, failed: false },
      message: ''
    }
  },
  computed: {
    actualBatchSize() {
      return parseInt(this.batchSize);
    },

    daysProgress() {
      if (this.totalDays === 0) return 0;
      return Math.round((this.completedDays / this.totalDays) * 100);
    },

    currentDayProgress() {
      if (this.currentDayTotal === 0) return 0;
      return Math.round((this.currentDayScanned / this.currentDayTotal) * 100);
    },

    currentDaySpeed() {
      if (this.currentDayElapsed === 0 || this.currentDayScanned === 0) return '0.00';
      return (this.currentDayScanned / this.currentDayElapsed).toFixed(2);
    },

    currentDayRemaining() {
      if (this.currentDayScanned === 0 || this.currentDayElapsed === 0) return 0;
      const remaining = this.currentDayTotal - this.currentDayScanned;
      const avgTime = this.currentDayElapsed / this.currentDayScanned;
      return Math.ceil(remaining * avgTime);
    },

    overallSpeed() {
      if (this.totalElapsedTime === 0 || this.totalScannedRecords === 0) return '0.00';
      return (this.totalScannedRecords / this.totalElapsedTime).toFixed(2);
    },

    estimatedTotalTimeRemaining() {
      if (this.totalScannedRecords === 0 || this.totalElapsedTime === 0) return 0;

      const remainingRecords = this.totalRecords - this.totalScannedRecords;
      const avgTimePerRecord = this.totalElapsedTime / this.totalScannedRecords;

      return Math.ceil(remainingRecords * avgTimePerRecord);
    },

    estimatedCompletionTime() {
      if (this.estimatedTotalTimeRemaining === 0) return '--:--:--';
      const completionDate = new Date(Date.now() + (this.estimatedTotalTimeRemaining * 1000));
      return moment(completionDate).format('HH:mm:ss');
    },

    deleteTimeRemaining() {
      if (this.deletedCount === 0 || this.deleteElapsedTime === 0) return 0;
      const remaining = this.totalToDelete - this.deletedCount;
      const avgTime = this.deleteElapsedTime / this.deletedCount;
      return Math.ceil(remaining * avgTime);
    }
  },
  mounted() {
    this.dateTo = moment().format('YYYY-MM-DD');
    this.dateFrom = moment().subtract(1, 'months').format('YYYY-MM-DD');
    this.menuAccess();
  },
  beforeUnmount() {
    this.stopAllTimers();
  },
  methods: {
    getRight,

    // =====================
    // TIMER METHODS
    // =====================
    startTotalTimer() {
      this.totalStartTime = Date.now();
      this.totalTimer = setInterval(() => {
        this.totalElapsedTime = Math.floor((Date.now() - this.totalStartTime) / 1000);
      }, 1000);
    },

    stopTotalTimer() {
      if (this.totalTimer) {
        clearInterval(this.totalTimer);
        this.totalTimer = null;
      }
    },

    startCurrentDayTimer() {
      this.currentDayStartTime = Date.now();
      this.currentDayElapsed = 0;
      this.currentDayTimer = setInterval(() => {
        this.currentDayElapsed = Math.floor((Date.now() - this.currentDayStartTime) / 1000);
      }, 1000);
    },

    stopCurrentDayTimer() {
      if (this.currentDayTimer) {
        clearInterval(this.currentDayTimer);
        this.currentDayTimer = null;
      }
    },

    startDeleteTimer() {
      this.deleteStartTime = Date.now();
      this.deleteElapsedTime = 0;
      this.deleteTimer = setInterval(() => {
        this.deleteElapsedTime = Math.floor((Date.now() - this.deleteStartTime) / 1000);
      }, 1000);
    },

    stopDeleteTimer() {
      if (this.deleteTimer) {
        clearInterval(this.deleteTimer);
        this.deleteTimer = null;
      }
    },

    stopAllTimers() {
      this.stopTotalTimer();
      this.stopCurrentDayTimer();
      this.stopDeleteTimer();
    },

    formatDuration(seconds) {
      if (seconds === 0 || isNaN(seconds)) return '00:00:00';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },

    // =====================
    // LOAD DAYS WITH RECORDS
    // =====================
    async loadDaysWithRecords() {
      this.loading = true;
      this.loadingMessage = 'Loading days with PAID records...';
      this.resetScanState();

      try {
        const data = new FormData();
        data.append("function", "getDaysWithRecords");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);

        const response = await execute(data, biller);

        if (response.data.success) {
          this.daysWithRecords = (response.data.data.days || []).map(day => ({
            ...day,
            status: 'pending'
          }));
          this.totalDays = response.data.data.totalDays || 0;
          this.totalRecords = response.data.data.totalRecords || 0;

          if (this.totalDays > 0) {
            this.showAlert('success', `Found ${this.totalDays} days with ${this.numberFormat(this.totalRecords)} PAID records. Click "Start Day-by-Day Scan" to begin.`);
          } else {
            this.showAlert('info', 'No PAID records found in the selected date range.');
          }
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load days');
        }
      } catch (error) {
        console.error('Error loading days:', error);
        this.showAlert('failed', 'An error occurred while loading days');
      } finally {
        this.loading = false;
      }
    },

    // =====================
    // DAY BY DAY SCAN
    // =====================
    async startDayByDayScan() {
      if (this.daysWithRecords.length === 0) {
        this.showAlert('info', 'No days to scan');
        return;
      }

      this.isProcessing = true;
      this.stopRequested = false;
      this.scanComplete = false;
      this.completedDays = 0;
      this.totalScannedRecords = 0;
      this.totalOrphanedFound = 0;
      this.orphanedBills = [];

      // Start total timer
      this.startTotalTimer();

      // Process each day
      for (let i = 0; i < this.daysWithRecords.length; i++) {
        if (this.stopRequested) {
          this.currentDayStatus = 'Stopped by user';
          break;
        }

        this.currentDayIndex = i;
        this.currentDay = this.daysWithRecords[i];
        this.daysWithRecords[i].status = 'processing';

        // Process this day
        const foundOrphaned = await this.processDay(this.currentDay.date);

        if (foundOrphaned) {
          // Stop and show orphaned records
          this.stoppedAtDate = this.currentDay.date;
          this.daysWithRecords[i].status = 'orphaned';
          this.stopTotalTimer();
          this.isProcessing = false;
          this.showAlert('info', `Found ${this.orphanedBills.length} orphaned records on ${this.formatDateLong(this.currentDay.date)}. Please delete them before continuing.`);
          return;
        }

        // Day completed successfully - no orphans
        this.completedDays++;
        this.daysWithRecords[i].status = 'completed';
      }

      // All done
      this.stopTotalTimer();
      this.stopCurrentDayTimer();
      this.isProcessing = false;
      this.currentDay = null;

      if (!this.stopRequested) {
        this.scanComplete = true;
        this.showAlert('success', `Scan complete! All ${this.numberFormat(this.totalScannedRecords)} records are valid.`);
      }
    },

    // =====================
    // PROCESS SINGLE DAY
    // =====================
    async processDay(date) {
      this.currentDayScanned = 0;
      this.currentDayOrphaned = 0;
      this.currentDayBills = [];
      this.currentDayStatus = 'Loading records...';
      this.currentDayTotal = 0;

      // Start day timer
      this.startCurrentDayTimer();

      try {
        // Fetch ALL records for this day
        const data = new FormData();
        data.append("function", "getBillDetailsByDay");
        data.append("date", date);

        const response = await execute(data, biller);

        if (!response.data.success) {
          this.currentDayStatus = 'Failed to load records';
          this.stopCurrentDayTimer();
          return false;
        }

        this.currentDayBills = response.data.data.billDetails || [];
        this.currentDayTotal = this.currentDayBills.length;

        if (this.currentDayTotal === 0) {
          this.currentDayStatus = 'No records for this day';
          this.stopCurrentDayTimer();
          return false;
        }

        this.currentDayStatus = 'Scanning records...';

        // Scan in batches
        const batchSize = this.actualBatchSize;

        for (let i = 0; i < this.currentDayBills.length; i += batchSize) {
          if (this.stopRequested) {
            break;
          }

          const batch = this.currentDayBills.slice(i, i + batchSize);
          const billNumbers = batch.map(item => item.billNo);

          this.currentDayStatus = `Scanning ${i + 1}-${Math.min(i + batchSize, this.currentDayTotal)} of ${this.currentDayTotal}...`;

          try {
            const checkData = new FormData();
            checkData.append("function", "checkBillsBatch");
            checkData.append("billNumbers", JSON.stringify(billNumbers));

            const checkResponse = await execute(checkData, biller);

            if (checkResponse.data.success && checkResponse.data.data.results) {
              checkResponse.data.data.results.forEach(result => {
                this.currentDayScanned++;
                this.totalScannedRecords++;

                if (!result.existsInTransactions) {
                  this.currentDayOrphaned++;
                  this.totalOrphanedFound++;

                  // Find and add to orphaned list
                  const bill = this.currentDayBills.find(b => b.billNo === result.billNo);
                  if (bill) {
                    this.orphanedBills.push(bill);
                  }
                }
              });
            }
          } catch (error) {
            console.error('Batch check error:', error);
          }

          // Small delay
          await new Promise(resolve => setTimeout(resolve, 50));
        }

        this.stopCurrentDayTimer();

        // Return true if orphaned records found
        if (this.currentDayOrphaned > 0) {
          this.currentDayStatus = `Found ${this.currentDayOrphaned} orphaned records`;
          return true;
        }

        this.currentDayStatus = 'All records valid ✓';
        return false;

      } catch (error) {
        console.error('Error processing day:', error);
        this.currentDayStatus = 'Error processing day';
        this.stopCurrentDayTimer();
        return false;
      }
    },

    // =====================
    // CONTINUE AFTER CLEANUP
    // =====================
    async continueAfterCleanup() {
      if (this.orphanedBills.length > 0) {
        this.showAlert('info', 'Please delete all orphaned records before continuing');
        return;
      }

      // Clear orphaned data
      this.orphanedBills = [];
      this.stoppedAtDate = null;

      // Mark current day as completed
      if (this.currentDayIndex >= 0 && this.currentDayIndex < this.daysWithRecords.length) {
        this.daysWithRecords[this.currentDayIndex].status = 'completed';
        this.completedDays++;
      }

      // Resume processing
      this.isProcessing = true;
      this.stopRequested = false;

      // Resume timer (add to existing time)
      const previousTime = this.totalElapsedTime;
      this.startTotalTimer();
      this.totalElapsedTime = previousTime;

      // Continue from next day
      for (let i = this.currentDayIndex + 1; i < this.daysWithRecords.length; i++) {
        if (this.stopRequested) {
          break;
        }

        this.currentDayIndex = i;
        this.currentDay = this.daysWithRecords[i];
        this.daysWithRecords[i].status = 'processing';

        const foundOrphaned = await this.processDay(this.currentDay.date);

        if (foundOrphaned) {
          this.stoppedAtDate = this.currentDay.date;
          this.daysWithRecords[i].status = 'orphaned';
          this.stopTotalTimer();
          this.isProcessing = false;
          this.showAlert('info', `Found ${this.orphanedBills.length} orphaned records on ${this.formatDateLong(this.currentDay.date)}.`);
          return;
        }

        this.completedDays++;
        this.daysWithRecords[i].status = 'completed';
      }

      // All done
      this.stopTotalTimer();
      this.stopCurrentDayTimer();
      this.isProcessing = false;
      this.currentDay = null;

      if (!this.stopRequested) {
        this.scanComplete = true;
        this.showAlert('success', `Scan complete! All ${this.numberFormat(this.totalScannedRecords)} records are valid.`);
      }
    },

    // =====================
    // STOP PROCESSING
    // =====================
    stopProcessing() {
      this.stopRequested = true;
      this.currentDayStatus = 'Stopping...';
    },

    // =====================
    // DELETE METHODS
    // =====================
    async deleteSingleRecord(billNo) {
      if (!confirm(`Delete orphaned bill: ${billNo}?`)) return;

      try {
        const data = new FormData();
        data.append("function", "deleteOrphanedBillDetail");
        data.append("billNo", billNo);

        const response = await execute(data, biller);

        if (response.data.success) {
          this.orphanedBills = this.orphanedBills.filter(item => item.billNo !== billNo);
          this.totalOrphanedFound--;
          this.showAlert('success', `Deleted ${billNo}`);
        } else {
          this.showAlert('failed', response.data.message || 'Delete failed');
        }
      } catch (error) {
        console.error('Delete error:', error);
        this.showAlert('failed', 'An error occurred');
      }
    },

    async deleteAllOrphaned() {
      if (this.orphanedBills.length === 0) return;

      if (!confirm(`⚠️ DELETE ${this.orphanedBills.length} ORPHANED RECORDS?\n\nThis action cannot be undone.`)) return;

      this.isDeleting = true;
      this.deletedCount = 0;
      this.totalToDelete = this.orphanedBills.length;
      this.deletionProgress = 0;

      this.startDeleteTimer();

      const toDelete = [...this.orphanedBills];
      let successCount = 0;

      for (let i = 0; i < toDelete.length; i++) {
        try {
          const data = new FormData();
          data.append("function", "deleteOrphanedBillDetail");
          data.append("billNo", toDelete[i].billNo);

          const response = await execute(data, biller);

          if (response.data.success) {
            this.orphanedBills = this.orphanedBills.filter(b => b.billNo !== toDelete[i].billNo);
            successCount++;
          }
        } catch (error) {
          console.error('Delete error:', error);
        }

        this.deletedCount = i + 1;
        this.deletionProgress = ((i + 1) / toDelete.length) * 100;

        await new Promise(resolve => setTimeout(resolve, 50));
      }

      this.stopDeleteTimer();
      this.isDeleting = false;
      this.totalOrphanedFound -= successCount;

      this.showAlert('success', `Deleted ${successCount} orphaned records in ${this.formatDuration(this.deleteElapsedTime)}. Click "Continue Scan" to proceed.`);
    },

    // =====================
    // RESET
    // =====================
    resetScanState() {
      this.stopAllTimers();
      this.daysWithRecords = [];
      this.totalDays = 0;
      this.totalRecords = 0;
      this.completedDays = 0;
      this.currentDayIndex = -1;
      this.currentDay = null;
      this.currentDayBills = [];
      this.currentDayScanned = 0;
      this.currentDayTotal = 0;
      this.currentDayOrphaned = 0;
      this.currentDayElapsed = 0;
      this.totalScannedRecords = 0;
      this.totalOrphanedFound = 0;
      this.totalElapsedTime = 0;
      this.orphanedBills = [];
      this.stoppedAtDate = null;
      this.scanComplete = false;
      this.isProcessing = false;
    },

    resetScan() {
      this.resetScanState();
    },

    // =====================
    // UI HELPERS
    // =====================
    getDayBadgeClass(day, index) {
      if (day.status === 'completed') return 'bg-success';
      if (day.status === 'orphaned') return 'bg-danger';
      if (day.status === 'processing') return 'bg-primary';
      if (index < this.currentDayIndex) return 'bg-success';
      return 'bg-secondary';
    },

    getDayIcon(day, index) {
      if (day.status === 'completed') return 'mdi mdi-check-circle';
      if (day.status === 'orphaned') return 'mdi mdi-alert-circle';
      if (day.status === 'processing') return 'mdi mdi-loading mdi-spin';
      return 'mdi mdi-clock-outline';
    },

    formatDateShort(dateString) {
      return moment(dateString).format('DD MMM');
    },

    formatDateLong(dateString) {
      return moment(dateString).format('dddd, DD MMMM YYYY');
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;
      setTimeout(() => this.clearAlerts(), 6000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Data Cleanup");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(e => console.error("Menu access error:", e.message));
    },

    gotTo(route) {
      this.$router.push(route);
    }
  }
}
</script>

<style scoped>
.card-header {
  padding: 1rem;
}

.badge {
  font-size: 0.8rem;
}

.progress {
  border-radius: 0.5rem;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.font-size-24 {
  font-size: 24px;
}

.toast-container {
  z-index: 9999;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.gap-2 {
  gap: 0.5rem;
}

.mdi-spin {
  animation: mdi-spin 1s infinite linear;
}

@keyframes mdi-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}
</style>